// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Typography */
.h1 {
    font-size: 2.25rem;
    font-weight: 800;
    line-height: 1.25;
    letter-spacing: -0.05em
}

.h2 {
    font-size: 1.875rem;
    font-weight: 800;
    line-height: 1.25;
    letter-spacing: -0.05em
}

.h3 {
    font-size: 1.875rem;
    letter-spacing: -0.017em;
    font-weight: 700;
    line-height: 1.25
}

.h4 {
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1.375;
    letter-spacing: -0.025em
}

@media (min-width: 768px) {
    .h1 {
        font-size: 2.75rem;
        line-height: 1.1;
        letter-spacing: -0.017em
    }

    .h2 {
        font-size: 2.25rem;
        line-height: 1.277;
        letter-spacing: -0.017em
    }
}

/* Buttons */
.btn,
.btn-sm {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    border-width: 1px;
    border-color: transparent;
    font-weight: 500;
    line-height: 1.375;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
    transition-duration: 150ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1)
}

.btn {
    margin-top: 2rem;
    padding-left: 2rem;
    padding-right: 2rem;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.btn-sm {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

/* Forms */
.form-input,
.form-textarea,
.form-multiselect,
.form-select,
.form-checkbox,
.form-radio {
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(209 213 219 / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity))
}
.form-input:focus,
.form-textarea:focus,
.form-multiselect:focus,
.form-select:focus,
.form-checkbox:focus,
.form-radio:focus {
    --tw-border-opacity: 1;
    border-color: rgb(107 114 128 / var(--tw-border-opacity))
}

.form-input,
.form-textarea,
.form-multiselect,
.form-select,
.form-checkbox {
    border-radius: 0.25rem
}

.form-input,
.form-textarea,
.form-multiselect,
.form-select {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 1rem;
    padding-right: 1rem
}

.form-input::placeholder,
.form-textarea::placeholder {
    --tw-placeholder-opacity: 1;
    color: rgb(107 114 128 / var(--tw-placeholder-opacity))
}

.form-select {
    padding-right: 2.5rem
}

.form-checkbox,
.form-radio {
    border-radius: 0.125rem;
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity))
}`, "",{"version":3,"sources":["webpack://./src/styles/utility-pattern.css"],"names":[],"mappings":"AAAA,eAAe;AAEX;IAAA,kBAA6D;IAA7D,gBAA6D;IAA7D,iBAA6D;IAA7D;AAA6D;;AAI7D;IAAA,mBAA6D;IAA7D,gBAA6D;IAA7D,iBAA6D;IAA7D;AAA6D;;AAI7D;IAAA,mBAAuC;IAAvC,wBAAuC;IAAvC,gBAAuC;IAAvC;AAAuC;;AAIvC;IAAA,iBAAqD;IAArD,gBAAqD;IAArD,kBAAqD;IAArD;AAAqD;;AAGzD;IAEQ;QAAA,kBAAe;QAAf,gBAAe;QAAf;IAAe;;IAIf;QAAA,kBAAe;QAAf,kBAAe;QAAf;IAAe;AAEvB;;AAEA,YAAY;AAGR;;IAAA,oBAA6I;IAA7I,mBAA6I;IAA7I,uBAA6I;IAA7I,sBAA6I;IAA7I,iBAA6I;IAA7I,yBAA6I;IAA7I,gBAA6I;IAA7I,kBAA6I;IAA7I,gKAA6I;IAA7I,wJAA6I;IAA7I,iLAA6I;IAA7I,0BAA6I;IAA7I;AAA6I;;AAI7I;IAAA,gBAA+B;IAA/B,kBAA+B;IAA/B,mBAA+B;IAA/B,oBAA+B;IAA/B,uBAA+B;IAA/B,+EAA+B;IAA/B,mGAA+B;IAA/B;AAA+B;;AAI/B;IAAA,kBAAuB;IAAvB,mBAAuB;IAAvB,mBAAuB;IAAvB,sBAAuB;IAAvB,0EAAuB;IAAvB,8FAAuB;IAAvB;AAAuB;;AAG3B,UAAU;AAON;;;;;;IAAA,iBAA4D;IAA5D,sBAA4D;IAA5D,yDAA4D;IAA5D,kBAA4D;IAA5D;AAA4D;AAA5D;;;;;;IAAA,sBAA4D;IAA5D;AAA4D;;AAQ5D;;;;;IAAA;AAAc;;AAOd;;;;IAAA,oBAAgB;IAAhB,uBAAgB;IAAhB,kBAAgB;IAAhB;AAAgB;;AAKhB;;IAAA,2BAA2B;IAA3B;AAA2B;;AAI3B;IAAA;AAAY;;AAKZ;;IAAA,uBAA+B;IAA/B,oBAA+B;IAA/B;AAA+B","sourcesContent":["/* Typography */\n.h1 {\n    @apply text-4xl font-extrabold leading-tight tracking-tighter;\n}\n\n.h2 {\n    @apply text-3xl font-extrabold leading-tight tracking-tighter;\n}\n\n.h3 {\n    @apply text-3xl font-bold leading-tight;\n}\n\n.h4 {\n    @apply text-2xl font-bold leading-snug tracking-tight;\n}\n\n@screen md {\n    .h1 {\n        @apply text-5xl;\n    }\n\n    .h2 {\n        @apply text-4xl;\n    }\n}\n\n/* Buttons */\n.btn,\n.btn-sm {\n    @apply font-medium inline-flex items-center justify-center border border-transparent rounded leading-snug transition duration-150 ease-in-out;\n}\n\n.btn {\n    @apply px-8 py-3 shadow-lg mt-8;\n}\n\n.btn-sm {\n    @apply px-4 py-2 shadow;\n}\n\n/* Forms */\n.form-input,\n.form-textarea,\n.form-multiselect,\n.form-select,\n.form-checkbox,\n.form-radio {\n    @apply bg-white border border-gray-300 focus:border-gray-500;\n}\n\n.form-input,\n.form-textarea,\n.form-multiselect,\n.form-select,\n.form-checkbox {\n    @apply rounded;\n}\n\n.form-input,\n.form-textarea,\n.form-multiselect,\n.form-select {\n    @apply py-3 px-4;\n}\n\n.form-input,\n.form-textarea {\n    @apply placeholder-gray-500;\n}\n\n.form-select {\n    @apply pr-10;\n}\n\n.form-checkbox,\n.form-radio {\n    @apply text-gray-800 rounded-sm;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
